// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container for the entire quiz generator page */
.quiz-generator-container {
  padding-top: 100px; /* Ensures enough space for the navbar */
  background-color: #e6d9b8;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Header for the quiz generator */
.quiz-generator-header {
  text-align: center;
  margin-bottom: 2rem;
  color: #005c69;
}

.quiz-generator-header h1 {
  font-size: 3rem;
  font-weight: bold;
}

/* Container for the input section */
.input-section {
  background-color: white;
  padding: 2rem;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  margin-bottom: 2rem;
  width: 100%;
  max-width: 800px;
}

.input-section textarea,
.input-section input {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  margin-bottom: 1rem;
  font-size: 1rem;
}

.input-section button {
  width: 100%;
  background-color: #005c69;
  color: white;
  font-weight: bold;
  padding: 0.75rem;
  border-radius: 0.375rem;
  transition: background-color 0.3s ease, transform 0.3s ease;
  cursor: pointer;
}

.input-section button:hover {
  background-color: #00404d;
  transform: scale(1.05);
}

.error-message {
  color: red;
  margin-top: 1rem;
}

/* Container for the quiz content */
.quiz-content {
  background-color: white;
  padding: 2rem;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  width: 100%;
  max-width: 800px;
}

.quiz-content h2 {
  text-align: center;
  color: #005c69;
  font-size: 2.5rem;
  margin-bottom: 2rem;
}

.submit-button, .export-button {
  width: 100%;
  background-color: #005c69;
  color: white;
  font-weight: bold;
  padding: 0.75rem;
  border-radius: 0.375rem;
  transition: background-color 0.3s ease, transform 0.3s ease;
  cursor: pointer;
  margin-top: 2rem;
}

.submit-button:hover, .export-button:hover {
  background-color: #00404d;
  transform: scale(1.05);
}

.score-section {
  text-align: center;
  margin-top: 2rem;
}

.score-section h3 {
  font-size: 2rem;
  color: #005c69;
}

.score-section button {
  margin-top: 1rem;
}

/* Export section styles */
.export-section {
  margin-top: 2rem;
  text-align: center;
}

.export-section select {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  margin-bottom: 1rem;
  font-size: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/quiz/FetchQuiz.css"],"names":[],"mappings":"AAAA,iDAAiD;AACjD;EACE,kBAAkB,EAAE,wCAAwC;EAC5D,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,oCAAoC;AACpC;EACE,uBAAuB;EACvB,aAAa;EACb,qBAAqB;EACrB,uEAAuE;EACvE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,2DAA2D;EAC3D,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,uBAAuB;EACvB,aAAa;EACb,qBAAqB;EACrB,uEAAuE;EACvE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,2DAA2D;EAC3D,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB","sourcesContent":["/* Container for the entire quiz generator page */\n.quiz-generator-container {\n  padding-top: 100px; /* Ensures enough space for the navbar */\n  background-color: #e6d9b8;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n/* Header for the quiz generator */\n.quiz-generator-header {\n  text-align: center;\n  margin-bottom: 2rem;\n  color: #005c69;\n}\n\n.quiz-generator-header h1 {\n  font-size: 3rem;\n  font-weight: bold;\n}\n\n/* Container for the input section */\n.input-section {\n  background-color: white;\n  padding: 2rem;\n  border-radius: 0.5rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);\n  margin-bottom: 2rem;\n  width: 100%;\n  max-width: 800px;\n}\n\n.input-section textarea,\n.input-section input {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.375rem;\n  margin-bottom: 1rem;\n  font-size: 1rem;\n}\n\n.input-section button {\n  width: 100%;\n  background-color: #005c69;\n  color: white;\n  font-weight: bold;\n  padding: 0.75rem;\n  border-radius: 0.375rem;\n  transition: background-color 0.3s ease, transform 0.3s ease;\n  cursor: pointer;\n}\n\n.input-section button:hover {\n  background-color: #00404d;\n  transform: scale(1.05);\n}\n\n.error-message {\n  color: red;\n  margin-top: 1rem;\n}\n\n/* Container for the quiz content */\n.quiz-content {\n  background-color: white;\n  padding: 2rem;\n  border-radius: 0.5rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);\n  width: 100%;\n  max-width: 800px;\n}\n\n.quiz-content h2 {\n  text-align: center;\n  color: #005c69;\n  font-size: 2.5rem;\n  margin-bottom: 2rem;\n}\n\n.submit-button, .export-button {\n  width: 100%;\n  background-color: #005c69;\n  color: white;\n  font-weight: bold;\n  padding: 0.75rem;\n  border-radius: 0.375rem;\n  transition: background-color 0.3s ease, transform 0.3s ease;\n  cursor: pointer;\n  margin-top: 2rem;\n}\n\n.submit-button:hover, .export-button:hover {\n  background-color: #00404d;\n  transform: scale(1.05);\n}\n\n.score-section {\n  text-align: center;\n  margin-top: 2rem;\n}\n\n.score-section h3 {\n  font-size: 2rem;\n  color: #005c69;\n}\n\n.score-section button {\n  margin-top: 1rem;\n}\n\n/* Export section styles */\n.export-section {\n  margin-top: 2rem;\n  text-align: center;\n}\n\n.export-section select {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.375rem;\n  margin-bottom: 1rem;\n  font-size: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
